module.exports = __webpack_public_path__ + "img/writemyname.b980b15f.png";